import { toast } from 'sonner'
import useStore from '@/stores/useStore'
import { getPresetSettings, PLAN_PRESETS } from '@/lib/planPresets'

export default function OnboardingStepPlan({ onNext }) {
  const applyPlanPreset = useStore((state) => state.applyPlanPreset)

  const applyPreset = (preset) => {
    if (!applyPlanPreset('planA', getPresetSettings(preset))) return
    toast.success(`Starting plan design: ${preset.name}`)
    onNext()
  }

  return (
    <div className="space-y-6">
      <div className="space-y-2 text-center">
        <h1 className="text-balance text-2xl font-semibold text-foreground">Pick a Starting Plan Design</h1>
        <p className="text-sm text-muted-foreground">
          Choose the closest starting point. You can change these choices later.
        </p>
      </div>

      <div className="grid gap-2 sm:grid-cols-2">
        {PLAN_PRESETS.map((preset) => (
          <button
            key={preset.name}
            type="button"
            onClick={() => applyPreset(preset)}
            className={[
              'flex flex-col gap-1 rounded-lg border px-4 py-3 text-left transition-colors hover:border-primary/50 hover:bg-accent/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
              preset.isStoreDefault ? 'border-primary/40 bg-card/80' : 'border-border bg-card/80',
            ].join(' ')}
          >
            <span className="flex items-center gap-2 text-sm font-semibold text-foreground">
              {preset.name}
              {preset.isStoreDefault && (
                <span className="rounded-full bg-primary/10 px-2 py-0.5 text-[10px] font-medium text-primary">
                  Recommended
                </span>
              )}
            </span>
            <span className="text-xs leading-4 text-muted-foreground">{preset.description}</span>
          </button>
        ))}
      </div>

      <div className="text-center">
        <button
          type="button"
          onClick={onNext}
          className="text-xs text-muted-foreground underline underline-offset-2 transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
        >
          Keep Current Plan
        </button>
      </div>
    </div>
  )
}
